<section class="faq-page">
  <div class="faq-backdrop"></div>
  <div class="faq-overlay"></div>

  <div class="container faq-shell">
    <section class="faq-panel">
      <div class="faq-intro">
        <p class="eyebrow">FAQ</p>
        <h1>Here For Your Queries</h1>
        <p class="faq-lead">
          A tech-driven venture builder focused on strategic growth. We identify
          high-potential opportunities, establish robust foundations, and scale
          innovative businesses designed for long-term endurance.
        </p>
      </div>

      <div class="faq-list">
        <article
          class="faq-card"
          [class.is-open]="expandedIndex === i"
          *ngFor="let item of faqs; let i = index"
        >
          <button
            class="faq-toggle"
            type="button"
            (click)="toggleFaq(i)"
            [attr.aria-expanded]="expandedIndex === i"
          >
            <span class="faq-question">{{ item.question }}</span>
            <span class="faq-icon" [class.is-open]="expandedIndex === i">
              {{ expandedIndex === i ? '×' : '+' }}
            </span>
          </button>

          <div class="faq-answer" [class.is-open]="expandedIndex === i">
            <p>{{ item.answer }}</p>
          </div>
        </article>
      </div>
    </section>
  </div>
</section>
